import { JSXElementConstructor, ReactElement, useMemo } from "react";
import LayoutTop from "./right-side/layout-top";
import { ReactNode } from "react";
import { useEffect, useState } from "react";
import HomeGoogleAds from "../../components/advertisement/home-google-ads";
import LoadHomeGoogleAds from "../../components/advertisement/load-home-google-ads";

type ContainerLayoutTypes = {
  breadcrumbPath: string;
  siteTop?: JSX.Element;
  children: ReactNode;
  isBreadcrumbPath: boolean;
  showAds?: boolean;
  showSocialMedia?: boolean;
};

const ContainerLayout = (props: ContainerLayoutTypes) => {
  const cachedGoogleAds = useMemo(() => <HomeGoogleAds />, []);
  const cachedUseDfpSlot = useMemo(() => <LoadHomeGoogleAds />, []);
  const [topLayoutClasses, setTopLayoutClasses] = useState("container two-column");

 // let certification root pages be full width
  useEffect(() => {
    if (props.breadcrumbPath.startsWith('certifications') && !props.isBreadcrumbPath) {
      setTopLayoutClasses('container-fluid two-column')
    }
  }, [props.breadcrumbPath]);

  return (
    <main id="site-main" className="site-main container-off" role="main">
      <div className="site-top">{props.siteTop !== undefined && props.siteTop}</div>
      <LayoutTop breadcrumbPath={props.breadcrumbPath} isBreadcrumbpath={props.isBreadcrumbPath} showSocialMedia={props.showSocialMedia} />
      {props.breadcrumbPath.startsWith('certifications') && props.isBreadcrumbPath && <hr style={{ borderTop: "1px solid #959595" }} />}
      <div className={topLayoutClasses}>
        <div className="row">
          <div className="col-md-12">
            <div className="mobile-jump-links">
              <ul className="list-unstyled">
                <li>
                  <a href="#navRail">
                    Skip to Navigation{" "}
                    <svg className="icomoon icomoon-circle-down">
                      <use xlinkHref="#icomoon-circle-down"></use>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
            {props.children}
          </div>
        </div>
        <p>&nbsp;</p>
        {props.showAds !== undefined && props.showAds && cachedGoogleAds}
        {props.showAds !== undefined && props.showAds && cachedUseDfpSlot}
        <p>&nbsp;</p>
      </div>
    </main>
  );
};

export default ContainerLayout;
